<template lang="pug">
  v-row(no-gutters)
    v-col(cols=12 md=6)
      v-sheet(color="transparent").enrollment-sheet.pl-4
        v-list
          v-subheader.d-flex.align-center
            .text-uppercase Обучающиеся
            tooltip-wrap(
              text="Выгрузить в формате .xlsx"
            )
              v-btn(
                text
                small
                fab
                color="secondary"
                :loading="loading.exportStudents"
                @click="exportStudents"
              ).ml-2
                v-icon mdi-download
            v-spacer
            v-switch(
              v-model="attestateMode"
              color="secondary"
              rounded
              text
              inset
              label="Режим аттестации"
              outlined
              hide-details
              @click="users.selected = []"
            ).pt-0.mt-0
          v-list-item.mb-2.px-0
            v-list-item-content
              v-select(
                v-if="attestateMode"
                v-model="attestateModeType"
                label="Тип"
                rounded
                filled
                outlined
                hide-details
                :items="$conf.ATTESTATION_STATUSES_ADMITTANCE"
              )
              v-text-field(
                v-else
                v-model="users.q"
                label="ФИО"
                hide-details
                rounded
                filled
                clearable
                outlined
              )
            v-list-item-action
              v-badge(
                :value="hasFilters"
                dot
                overlap
                left
                offset-x="15"
                offset-y="15"
                color="secondary"
              )
                v-btn(
                  fab
                  text
                  @click="setFilters"
                )
                  v-icon mdi-tune
          v-fade-transition(leave-absolute)
            v-skeleton-loader(
              v-if="loading.users"
              type="list-item-two-line@5"
            )
          v-list-item(v-if="!loading.users && !users.items.length")
            v-list-item-content
              v-list-item-subtitle Студенты не найдены...

          lazy-load(
            v-if="!loading.users"
            v-model="users.loadMore"
            @on-response="({ items }) => users.items.push(...items)"
          )
            v-list-item-group(
              v-model="users.selected"
              :multiple="attestateMode"
            )
              v-list-item(
                v-for="(user, idx) in users.items"
                :key="idx"
                :value="user"
              ).my-1
                template(#default="{ active }")
                  v-list-item-avatar
                    v-checkbox(
                      v-if="attestateMode"
                      color="grey darken-2"
                      :input-value="active"
                    )
                    v-avatar(
                      v-else
                    )
                      v-icon(:color="user.statusColor") mdi-account-school
                  v-list-item-content
                    v-list-item-title {{ user.full_name }}
                    v-list-item-subtitle.mb-2 {{ user.record.group.short_name }}
                    v-list-item-subtitle.d-flex(
                      :class="{ 'opacity': !active }"
                    )
                      .mr-2(v-if="user.course_tasks")
                        tooltip-wrap(
                          v-if="user.courseWorkDone"
                          text="Курсовая работа выполнена"
                        )
                          v-icon(
                            :color="`${user.statusColor} darken-1`"
                            size="28"
                          ) mdi-file-document-check
                        tooltip-wrap(
                          v-else
                          text="Курсовая работа не выполнена"
                        )
                          v-icon(
                            :color="`${user.statusColor} darken-1`" size="28"
                          ) mdi-file-document-outline

                      v-sheet(
                        color="transparent"
                        max-width="150"
                      )
                        v-progress-linear(
                          :value="(100 / course.course_units_count) * user.passed_course_unit_count"
                          :color="`${user.statusColor} darken-1`"
                          height="6"
                          rounded
                        ).my-1
                        .caption {{ user.passed_course_unit_count }}
                          |/{{ course.course_units_count }} тем пройдено
                  v-list-item-action
                    v-list-item-subtitle
                      v-chip(
                        :color="`grey lighten-5`"
                        small
                      )
                        span(:class="`${user.statusColor}--text text--darken-1`")
                          | {{ $conf.ATTESTATION_STATUSES_TEXT[user.status] }}
                    v-tooltip(top)
                      template(#activator="{ on }")
                        v-chip.pr-0(
                          v-on="on" x-small :color="user.isValidAttrs ? 'success' : 'warning'"
                        )
                          v-chip(
                            v-if="user.statements.length > 1 || user.scanRequired"
                            small :color="user.isValidState ? 'success' : 'warning'"
                            ).pl-0
                      span {{user.isValidAttrs ? 'Все данные заполнены' : 'Данные не заполнены'}}
                      div(
                        v-if="user.statements.length > 1 || user.scanRequired"
                      ) {{ user.isValidState ? 'Все файлы загружены' : 'Файл(ы) не загружены'}}

    v-col(
      v-if="attestateMode"
      cols=12 md=6
    )
      .grey.lighten-5.fill-height
        v-card(flat color="transparent").fill-height.d-flex.align-center
          v-card-text.text-center
            .text-h5.my-3 Аттестация
            p Выбрано всего
              strong  {{ users.selected.length }}
            .my-5
              v-btn(
                v-if="attestateMode && attestateModeType === $conf.ATTESTATION_STATUSES.enrolled"
                color="secondary"
                depressed
                rounded
                x-large
                :disabled="!users.selected.length"
                :loading="loading.changeStatusMass"
                @click="changeStatusMass($conf.ATTESTATION_STATUSES.allowedAttestation)"
              )
                span Допустить к аттестации
                v-icon(right) mdi-checkbox-marked-circle-outline
              v-btn(
                v-else
                color="success"
                depressed
                rounded
                x-large
                :disabled="!users.selected.length"
                :loading="loading.changeStatusMass"
                @click="changeStatusMass($conf.ATTESTATION_STATUSES.attestated)"
              )
                span Аттестовать выбранных
                v-icon(right) mdi-book-education-outline
    v-col(
      v-else
      cols=12 md=6
    )
      v-sheet(color="transparent").enrollment-sheet.grey.lighten-5
        v-card(flat color="transparent").fill-height
          .d-flex.justify-center.align-center.fill-height(v-if="!studentOpened")
            v-sheet(color="transparent" max-width=120).text-center
              v-icon(
                size=100
                color="secondary"
              ) mdi-account-school-outline
              .caption Выбрерите студента из списка
          v-card-text(v-else)
            .ml-4
              .d-flex.align-center
                tooltip-wrap(
                  text="Перейти в профиль"
                )
                  v-btn(
                    fab
                    outlined
                    small
                    text
                    :to=`{
                      name: "StudentReview",
                      params: { id: users.selected.user_id },
                    }`
                    target="_blank"
                    @click.stop=""
                  )
                    v-icon mdi-account-school
                .ml-3
                  .text-h5 {{ users.selected.full_name }}
                  a(
                    v-if="users.selected.status === $conf.ATTESTATION_STATUSES.attestated"
                    @click="cancelAttestation"
                  ).secondary--text.caption Аттестован по ошибке?
                  a(
                    v-if="users.selected.status === $conf.ATTESTATION_STATUSES.allowedAttestation"
                    @click="cancelAllowAttestation"
                  ).secondary--text.caption Допущен к аттестации по ошибке?
                  a(
                    v-if="users.selected.status === $conf.ATTESTATION_STATUSES.refusedAttestation"
                    @click="cancelRefuseAttestation"
                  ).secondary--text.caption Не аттестован по ошибке?

              v-expand-transition
                v-alert(
                  v-if=`users.selected.diplomData
                    && users.selected.status === $conf.ATTESTATION_STATUSES.attestated`
                  color="secondary"
                  outlined
                  text
                ).mt-4
                  strong Почтовые данные для отправки документа об образовании
                  div.mt-5
                    strong.mr-1 Кому
                    span {{ users.selected.diplomData.whom }}
                  div
                    strong.mr-1 Куда
                    span {{ users.selected.diplomData.where }}

            v-fade-transition(leave-absolute)
              v-skeleton-loader(
                v-if="loading.userProgress"
                type="list-item-two-line@5"
              )

            v-list(
              v-if="!loading.userProgress"
              nav color="transparent"
            )
              v-subheader.d-flex.align-center
                .text-uppercase Прохождение курса
              v-list-item(
                v-for="(unit, idx) in users.selected.progress"
                :key="idx"
              )
                v-list-item-avatar
                  v-progress-circular(
                    width="20"
                    size="40"
                    :color="unit.statusColor"
                    :value="unit.progress"
                  )
                v-list-item-content
                  v-list-item-title.pre-wrap
                    span {{ unit.title }}
                  v-list-item-subtitle
                    span {{ unit.lessonsPassed.length }}/{{ unit.lessons.length }}
                    span  уроков завершено

            v-card-actions(
              v-if="users.selected.status === $conf.ATTESTATION_STATUSES.enrolled"
            )
              v-btn(
                color="secondary"
                depressed
                rounded
                large
                :disabled="!users.selected.isValidAttrs"
                :loading="loading.allowAttestation"
                @click="allowAttestation"
              ).my-2.px-8
                span Допустить к аттестации
                v-icon.ml-2 mdi-checkbox-marked-circle-outline
            v-card-actions(
              v-if="users.selected.status === $conf.ATTESTATION_STATUSES.allowedAttestation"
            )
              v-btn(
                color="secondary"
                depressed
                rounded
                large
                :loading="loading.attestate"
                @click="attestate"
              ).my-2.px-8
                span Аттестовать
                v-icon.ml-2 mdi-book-education-outline
              v-btn.my-5(
                color="warning lighten-1"
                depressed
                rounded
                large
                :loading="loading.refuseAttestation"
                @click="refuseAttestation"
              ).my-2.ml-2.px-8
                span Отказ в аттестации
</template>

<script>
import FileDownload from 'js-file-download';

import EnrollmentAttestationFilters from '@/modules/CourseManagement/components/Enrollment/EnrollmentAttestationFilters.vue';

export default {
  props: {
    course: { type: Object, required: true },
    enrollment: { type: Object, required: true },
    groups: { type: Array, default: () => ([]) },
  },
  data() {
    return {
      attestateMode: null,
      attestateModeType: null,

      users: {
        q: null,
        searchKeys: null,
        items: [],
        loadMore: null,
        selected: null,
      },
      units: [],

      loading: {
        users: true,
        allowAttestation: false,
        attestate: false,
        refuseAttestation: false,
        userProgress: false,
        changeStatusMass: false,
        loadMore: false,
        exportStudents: false,
      },
    };
  },
  computed: {
    studentOpened() {
      return this.users.selected && !Array.isArray(this.users.selected);
    },
    queryFilterParams() {
      return {
        expand: 'attributes,statements',
        'search[is_attestation]': true,
        'search[prior_record_status]': this.attestateModeType,
        'search[full_name]': this.users.q,
        ...this.users.searchKeys,
      };
    },
    hasFilters() {
      if (!this.users.searchKeys) return false;
      return !!Object.values(this.users.searchKeys).find((v) => v);
    },
  },
  watch: {
    'users.selected': async function (user) {
      if (this.studentOpened && !user.progress.length) {
        this.loading.userProgress = true;
        const methods = [user.fetchStudentProgress(this.course.id)];

        if (user.status === this.$conf.ATTESTATION_STATUSES.attestated) {
          methods.push(user.fetchDiplomData(this.enrollment.id));
        }
        await Promise.all(methods);
        this.loading.userProgress = false;
      }
    },
    attestateMode(val) {
      this.users.q = null;
      if (val) {
        this.attestateModeType = this.$conf.ATTESTATION_STATUSES.enrolled;
      } else {
        this.attestateModeType = null;
      }
    },
    attestateModeType() {
      this.users.selected = [];
    },
    queryFilterParams() {
      this.fetchUsers();
    },
  },
  created() {
    this.fetchUsers();
  },
  methods: {
    cancelAttestation() {
      this.$modals.show('confirm-controller', {
        title: 'Отменить аттестацию',
        message: 'Статус ученика будет возвращен в статус "Зачислен"',
        method: () => this.users.selected.enroll(),
      });
    },
    cancelAllowAttestation() {
      this.$modals.show('confirm-controller', {
        title: 'Отменить допуск к аттестации',
        message: 'Статус ученика будет возвращен в статус "Зачислен"',
        method: () => this.users.selected.enroll(),
      });
    },
    cancelRefuseAttestation() {
      this.$modals.show('confirm-controller', {
        title: 'Отменить статус "Не аттестован"',
        message: 'Статус ученика будет возвращен в статус "Зачислен"',
        method: () => this.users.selected.enroll(),
      });
    },
    async allowAttestation() {
      this.loading.allowAttestation = true;
      await this.users.selected.allowAttestation();
      this.loading.allowAttestation = false;
    },
    async changeStatusMass(status) {
      this.loading.changeStatusMass = true;
      const records = this.users.selected.map((u) => ({
        prior_record_user_id: u.id,
        status,
      }));
      await this.$api.enrollments.changeStatusMass(records);
      this.users.selected = [];
      this.attestateMode = false;
      this.loading.changeStatusMass = false;
    },
    async attestate() {
      this.loading.attestate = true;
      await this.users.selected.attestate();
      this.loading.attestate = false;
    },
    async refuseAttestation() {
      this.loading.refuseAttestation = true;
      await this.users.selected.refuseAttestation();
      this.loading.refuseAttestation = false;
    },
    async fetchUsers() {
      this.loading.users = true;
      const { items, loadMore } = await this.$api.enrollments.enrollmentUsers(
        this.enrollment.id, this.queryFilterParams,
      );
      this.users.items = items;
      this.users.items.forEach((i) => i.setupAttributes(this.enrollment.attributes));
      this.users.loadMore = loadMore;
      this.loading.users = false;
    },
    setFilters() {
      this.$modals.show('confirm-controller', {
        title: 'Фильтрация учеников',
        message: null,
        icon: 'mdi-tune',
        method: (data) => { this.users.searchKeys = data; },
        component: EnrollmentAttestationFilters,
        componentInitialData: this.users.searchKeys,
        'component-props': {
          course: this.course,
        },
      });
    },
    async exportStudents() {
      this.loading.exportStudents = true;
      const resp = await this.$api.enrollments.exportStudents(this.enrollment.id);
      FileDownload(resp.data, `${this.course.title} - Студенты из набора.xlsx`);
      this.loading.exportStudents = false;
    },
  },
};
</script>
